<div id="login-container">
  <div class="row split-container">
    <nav class="navbar navbar-expand-lg">
      <div class="container-fluid">
        <!-- Push menu to right -->
        <div class="ms-auto">
          <ul class="nav-links">
            <!-- Mega Dropdown -->
            <li class="menu-item dropdown position-static">
              <a
                href="#"
                id="megaMenu"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="bx bx-link me-2 header-icon"></i>
                Quick Links
              </a>

              <!-- MEGA MENU -->
              <div class="dropdown-menu w-100 border-0 shadow-lg p-4">
                <div class="container">
                  <div class="row">
                    <!-- COLUMN 1 -->
                    <div class="col-lg-3 col-md-6 mb-4 mega-col">
                      <h6 class="mega-title">PIAS Portal</h6>
                      <ul class="list-unstyled mega-links">
                        <li>
                          <a href="https://pias.sg/privilege-card.html" target="_blank"
                            >PIAS Premier Client Privilege</a
                          >
                        </li>
                        <li>
                          <a href="https://gi.proinvest.com.sg/login" target="_blank" rel="noopener"
                            >PIAS Instant Gi Compare Tool</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://singlife.my.site.com/LMS/s/login/"
                            target="_blank"
                            rel="noopener"
                            >PIAS Salesforce Leads Management System</a
                          >
                        </li>
                        <li>
                          <a href="https://iam.singlife.com/" target="_blank" rel="noopener"
                            >PIAS eFNA</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://lms.wizlearn.com/pias/Login/Login_pias.aspx?returnUrl=/pias/"
                            target="_blank"
                            rel="noopener"
                            >PIAS Wizlearn e-learning</a
                          >
                        </li>
                        <!-- <li>
                                                    <a href="https://iam.singlife.com/app/singlife-adviser_vueprod_1/exk3fg20oqeSKKcGW3l7/sso/saml"
                                                        target="_blank" rel="noopener">VUE Producer Portal</a>
                                                </li> -->
                        <li>
                          <a
                            href="https://docushare.proinvest.com.sg/docushare/dsweb/HomePage"
                            target="_blank"
                            rel="noopener"
                            >DocuShare</a
                          >
                        </li>
                        <!-- <li>
                                                    <a href="https://www.proinvest.com.sg/our-services/clientprivileges-partners"
                                                        target="_blank" rel="noopener">PIAS Premier Client Privilege</a>
                                                </li> -->
                      </ul>
                    </div>

                    <!-- COLUMN 2 -->
                    <div class="col-lg-5 col-md-6 mb-4 mega-col">
                      <h6 class="mega-title">Life & Investment</h6>

                      <div class="row">
                        <div class="col-6">
                          <ul class="list-unstyled mega-links">
                            <li>
                              <a href="https://iam.singlife.com/" target="_blank" rel="noopener"
                                >PIAS eFNA</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://ezsub.singlife.com/web/login/"
                                target="_blank"
                                rel="noopener"
                                >Singlife EzSub</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://applogin.singlife.com/SQS/login/"
                                target="_blank"
                                rel="noopener"
                                >Singlife Pocket SQS Quotation</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://applogin.singlife.com/adviser/#/login"
                                target="_blank"
                                rel="noopener"
                                >Singlife Online Portal</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://tlbconnect.transamericalifebermuda.com/"
                                target="_blank"
                                rel="noopener"
                                >Transamerica TLBConnect</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://tmwise.tokiomarine-life.sg/"
                                target="_blank"
                                rel="noopener"
                                >Tokio Marine TM WISE</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://tmconnect.tokiomarine-life.sg/"
                                target="_blank"
                                rel="noopener"
                                >Tokio Marine TM Connect</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://partner-dashboard.getcare.io/insurance"
                                target="_blank"
                                rel="noopener"
                                >Raffles Health Insurance- Agent Login</a
                              >
                            </li>
                        
                             <li>
                    <a href="https://www.insurance.hsbc.com.sg/help/agents/"
                      target="_blank" rel="noopener">HSBC Life</a>
                  </li>
                          </ul>
                        </div>

                        <div class="col-6">
                          <ul class="list-unstyled mega-links">
                            <li>
                              <a
                                href="https://www.fwd.com.sg/iSmartWeb/home/client-profile"
                                target="_blank"
                                rel="noopener"
                                >FWD SMART</a
                              >
                            </li>
                            <li>
                              <a href="https://incsso.income.com.sg/" target="_blank" rel="noopener"
                                >Income eApp</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://fa.manuview.sg/bis/aws_main_partner.jsp"
                                target="_blank"
                                rel="noopener"
                                >Manulife Manuview</a
                              >
                            </li>
                            <li>
                              <a href="https://api.emmprd.asia.manulife.com/ext/pos-web-app-sgp/mcf_redirect" target="_blank" rel="noopener"
                                >Manulife M360</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://ispeed.cntaiping.sg/ui/ipad-main/#/pages/login/index"
                                target="_blank"
                                rel="noopener"
                                >China Taiping iSpeed</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://www.etiqa.com.sg/iConnect/Agent/Login"
                                target="_blank"
                                rel="noopener"
                                >eTiQa iConnect</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://secure.ifastnetwork.com/ifa/adviser/login"
                                target="_blank"
                                rel="noopener"
                                >iFAST Central</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://secure.ifastgp.com/ifastgp/adviser/login"
                                target="_blank"
                                rel="noopener"
                                >iFAST Global Prestige (IGP)</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://www.tigerbrokers.com.sg/acct/auth/login?next=%2F"
                                target="_blank"
                                rel="noopener"
                                >Tiger brokers (Singapore)</a
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <!-- COLUMN 3 -->
                    <div class="col-lg-4 col-md-12 mb-4 mega-col">
                      <h6 class="mega-title">GI</h6>

                      <div class="row">
                        <div class="col-6">
                          <ul class="list-unstyled mega-links">
                            <li>
                              <a
                                href="https://applogin.singlife.com/adviser/#/login"
                                target="_blank"
                                rel="noopener"
                                >Singlife Online Portal</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://tmonline.tokiomarine.com.sg/aic/login/login.jsp"
                                target="_blank"
                                rel="noopener"
                                >Tokio Marine Gi - TM Online</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://singapore.merimen.com/epolicy/?lf=EPLRSASG"
                                target="_blank"
                                rel="noopener"
                                >Allied World Merimen</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://my-aw-portal.alliedworld.cloud/user/login"
                                target="_blank"
                                rel="noopener"
                                >Allied World Pricelink</a
                              >
                            </li>
                            <li>
                              <a href="https://www.ichannel.com.sg/" target="_blank" rel="noopener"
                                >Sompo iChannel</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://azconnect.allianz.sg/intermediaries/#/"
                                target="_blank"
                                rel="noopener"
                                >Allianz</a
                              >
                            </li>
                            <li>
                              <a href="https://qnect.qbe.com/sg/" target="_blank" rel="noopener"
                                >QBE QNECT</a
                              >
                            </li>
                            <li>
                              <a href="https://hub2.apac.chubb.com/" target="_blank" rel="noopener"
                                >Chubb Producer Hub</a
                              >
                            </li>
                          </ul>
                        </div>

                        <div class="col-6">
                          <ul class="list-unstyled mega-links">
                            <li>
                              <a
                                href="https://incsso.income.com.sg/login/login.jsp?TYPE=33554432&REALMOID=06-921a7cf0-d1ca-4124-aed2-a80058c5a1df&GUID=&SMAUTHREASON=0&METHOD=GET&SMAGENTNAME=mpGg9VyWTnsLkKGFQy0dzGSiVD4R1XDkayfh2cmXYMiVHlowlTpLNmtDSocrx8r3&TARGET=-SM-http%3a%2f%2fincsso%2eincome%2ecom%2esg%2flogin%2findex%2ejsp"
                                target="_blank"
                                rel="noopener"
                                >Income GI - Easy Portal</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://online.libertyinsurance.com.sg/Portal/login"
                                target="_blank"
                                rel="noopener"
                                >Liberty OneLiberty</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://www.etiqa.com.sg/iConnect/Agent/Login"
                                target="_blank"
                                rel="noopener"
                                >eTiQa iConnect</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://azssgpb2c.b2clogin.com/azssgpb2c.onmicrosoft.com/B2C_1_signin/oauth2/v2.0/authorize?client_id=14a15f7f-3f66-4f38-b04e-7b86f96d8e24&redirect_uri=https%3A%2F%2Fshop.directasia.com%2Fagent%2Fpostlogin/&scope=https%3A%2F%2Fazssgpb2c.onmicrosoft.com%2Fagency%2Fall.readwrite&response_type=code&state=UVuX4njKa1aDRSum2MC5JywisXdL9X&code_challenge=ocYCWfMwcSjWZok91g7EAZsKLdqPI7Nn_qoUWIdHHM4&code_challenge_method=S256"
                                target="_blank"
                                rel="noopener"
                                >Direct Asia</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://ibiz.cntaiping.sg/#/page/login"
                                target="_blank"
                                rel="noopener"
                                >China Taiping Gi</a
                              >
                            </li>
                            <li>
                              <a href="https://www.msig.com.sg/" target="_blank" rel="noopener"
                                >MSIG mConnect</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://internet.eqinsurance.com.sg/eqwap/plogin/"
                                target="_blank"
                                rel="noopener"
                                >EQ Insurance E-Portal</a
                              >
                            </li>
                            <li>
                              <a
                                href="https://www-6.aig.com/apaclogin/login/apac/jsp/apac_phome_en_sp_SG.jsp?state=NzkxNzQwNzR8MzM1NTQ0MzM&TYPE=33554433&REALMOID=06-000c5345-0cb8-10e9-bf08-0af90a570000&GUID=&SMAUTHREASON=0&METHOD=GET&SMAGENTNAME=-SM-K8FAx13GXuQUPrBbBv0hx2IjI2eOk2fhs0BUIPMeUVBe%2bvEWOVtuvUO3e667ZOW3&TARGET=-SM-HTTPS%3a%2f%2fwww--6%2eaig%2ecom%2fwps%2fmyportal%2fapac%2fprivate%3fapp%3d2fa_sg"
                                target="_blank"
                                rel="noopener"
                                >AIG myAIG Login</a
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="col-md-6 form-section d-flex align-items-center justify-content-center">
      <div id="login-form-container">
        <!-- PIAS Logo -->
        <p>
          <img
            src="assets/images/PIAS-logo.png"
            alt="PIAS-logo"
            id="pias-logo"
            class="img img-fluid"
          />
        </p>

        <!-- Maintenance Card -->
        @if (this.isMaintenanceMode()) {
          <div class="maintenance-card">
            <div class="maintenance-header">
              <i class="bx bx-info-circle maintenance-icon"></i>
              <span class="maintenance-title">{{ this.maintenanceType() }}</span>
            </div>

            <p class="maintenance-body">{{ this.maintenanceMessage() }}</p>
          </div>
        }
        <div class="card">
          <div class="card-body">
            <p class="card-title mb-4 h4 fw-bold">Login</p>

            <!-- Login Form -->
            <form class="w-100" [formGroup]="loginFg">
              <p class="w-100">
                <mat-form-field class="w-100" [hideRequiredMarker]="true">
                  <mat-label>Username</mat-label>
                  <input matInput type="text" formControlName="username" required />
                  @if (
                    this.loginFg.controls['username'].invalid &&
                    (this.loginFg.controls['username'].touched ||
                      this.loginFg.controls['username'].dirty)
                  ) {
                    <mat-error>
                      @if (this.loginFg.controls['username'].errors?.['required']) {
                        <span>Username is required.</span>
                      } @else if (this.loginFg.controls['username'].errors?.['username']) {
                        <span>Invalid username.</span>
                      } @else {
                        <span></span>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </p>
              <p class="w-100">
                <mat-form-field class="w-100" [hideRequiredMarker]="true">
                  <mat-label>Password</mat-label>
                  <input
                    matInput
                    [type]="passwordHide() ? 'password' : 'text'"
                    formControlName="password"
                    required
                  />
                  <button
                    type="button"
                    matIconButton
                    matSuffix
                    (click)="passwordHideToggle($event)"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="passwordHide()"
                  >
                    <mat-icon>{{ passwordHide() ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  @if (
                    this.loginFg.controls['password'].invalid &&
                    (this.loginFg.controls['password'].touched ||
                      this.loginFg.controls['password'].dirty)
                  ) {
                    <mat-error>
                      @if (this.loginFg.controls['password'].errors?.['required']) {
                        <span>Password is required.</span>
                      } @else {
                        <span></span>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </p>
              <div class="w-100 my-3 d-flex justify-content-between align-items-baseline">
                <mat-checkbox class="pias-label" formControlName="saveInfoCb"
                  >Remember me</mat-checkbox
                >
                <a [routerLink]="'/forgot-password'" class="pias-link">Forgot Password?</a>
              </div>
              <p class="w-100">
                <button
                  type="submit"
                  id="login-btn"
                  class="btn"
                  [disabled]="this.loginFg.invalid || this.isLoginLoading()"
                  (click)="authenticateUser()"
                >
                  @if (this.isLoginLoading()) {
                    <span class="spinner-grow spinner-grow-sm" aria-hidden="true"></span>
                    <span class="ms-1 fw-normal" role="status">Loading...</span>
                  } @else {
                    <span>Login</span>
                  }
                </button>
              </p>
              <p class="w-100">
                New user?
                <a [routerLink]="'/register-new-user'" class="pias-link">Register here</a>
              </p>
              <p class="w-100">
                <button type="button" id="singpass-btn" class="btn invisible">
                  Login with
                  <img src="assets/images/singpass-logo-white.svg" alt="SingPass" width="80" />
                </button>
              </p>
            </form>
          </div>
        </div>

        <!-- Footer -->
        <div id="pias-footer">
          <p>© 2025 Professional Investment Advisory Services Pte Ltd</p>
        </div>
      </div>
      <!-- <img src="assets/images/Leave-only.jpg" alt="Login Image" /> -->
    </div>
    <div class="col-md-6 image-section d-none d-md-flex">
      <img src="assets/images/PIAS-leaves.png" alt="Login Image" />
    </div>
  </div>
</div>
